/* ms-gallery.js - Slide-Galerie fuer Hotel-, Challenge- und Gutscheinseiten
   (Vorgabe Fabian 15.09.2026: "diese Art von Galerie ueberall").

   Das gewaehlte Bild schiebt sich direkt ueber das aktuelle - vorwaerts von
   rechts, zurueck von links, ca. 1 s. Immer genau ein Uebergang, auch bei
   Spruengen; das zuletzt gewaehlte Bild bleibt stehen. Das untere Bild weicht
   mit Parallaxe aus und dunkelt ab (--dim), im oberen laeuft das Foto mit
   halber Geschwindigkeit mit. Nur transform, per requestAnimationFrame.
   Punkte hoechstens 5 mit wanderndem Fenster (wie updateNav der Challenge-
   Galerie), Pfeile, Wischen, Pfeiltasten.

   window.MSGallery.create(opts) -> api
     root        Element fuer Wischen und Pfeiltasten
     slides      alle Slides in fester DOM-Reihenfolge
     mains       Hauptslides mit Punkt (Standard: alle)
     dots        Punkt-Knoepfe (hoechstens 5)
     dotLabel    Vorlage "Bild %i von %n" fuer aria-label
     prev, next  Pfeil-Elemente
     onClass     Klasse des sichtbaren Slides (Standard "is-on")
     swipeIgnore Selektor, auf dem kein Wischen beginnt (Standard "button")
     reduce      reduzierte Bewegung (Standard: prefers-reduced-motion)
     onMark(n, mainIndex, slide)  logischer Wechsel (sofort, vor der Fahrt)
   api: show(slide, D) (D === 0: ohne Fahrt), showMain(i, D), step(+1|-1),
        current(), currentIndex(), lastMain(), slides, mains */
(function () {
  'use strict';
  if (window.MSGallery) return;

  function bez(x1, y1, x2, y2) {
    return function (t) {
      if (t <= 0) return 0;
      if (t >= 1) return 1;
      var lo = 0, hi = 1, s = t;
      for (var i = 0; i < 20; i++) { var u = 1 - s, x = 3 * u * u * s * x1 + 3 * u * s * s * x2 + s * s * s; if (x < t) lo = s; else hi = s; s = (lo + hi) / 2; }
      var v = 1 - s;
      return 3 * v * v * s * y1 + 3 * v * s * s * y2 + s * s * s;
    };
  }
  var EASE_GO = bez(0.7, 0, 0.2, 1), EASE_ON = bez(0.22, 0.61, 0.36, 1);
  var PAR = 0.25, DIM = 0.38, INNER = 0.5, ZOOM = 0.06, DUR = 1050;
  var arr = function (x) { return Array.prototype.slice.call(x || []); };

  function create(o) {
    var gs = arr(o.slides), mains = o.mains ? arr(o.mains) : gs.slice(), dots = arr(o.dots);
    var ON = o.onClass || 'is-on', dotTpl = o.dotLabel || '';
    var reduce = typeof o.reduce === 'boolean' ? o.reduce : window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!gs.length) return null;
    var cur = 0;
    for (var k = 0; k < gs.length; k++) { if (gs[k].classList.contains(ON)) { cur = k; break; } }
    var lastMain = Math.max(0, mains.indexOf(gs[cur]));
    /* Fahrt: trail = Slide-Indizes der Strecke, pos = Lage darauf (Kommazahl),
       dirs = Richtung je Abschnitt (1 = von rechts, -1 = von links). Gemalt
       werden nur zwei Slides: unten (weicht aus, dunkelt ab) und oben. */
    var trail = [cur], dirs = [], pos = 0, run = null, painted = [], winStart = 0;
    var imgOf = function (s) { return s.querySelector('img'); };
    /* Ladezeit: Bilder ausser dem ersten tragen ihre Quelle als data-ms-src/-srcset
       (sonst laden uebereinanderliegende Slides alle auf einmal). Gesetzt wird sie,
       sobald ein Slide gezeigt oder als Nachbar vorgeladen wird. */
    var hydrate = function (s) {
      if (!s) return;
      var ims = s.querySelectorAll('img[data-ms-src]');
      for (var j = 0; j < ims.length; j++) {
        var im = ims[j];
        if (im.getAttribute('data-ms-srcset')) im.setAttribute('srcset', im.getAttribute('data-ms-srcset'));
        im.setAttribute('src', im.getAttribute('data-ms-src'));
        im.removeAttribute('data-ms-src'); im.removeAttribute('data-ms-srcset');
      }
    };
    var warm = function (n) { hydrate(gs[n]); hydrate(gs[(n + 1) % gs.length]); hydrate(gs[(n - 1 + gs.length) % gs.length]); };
    var clearSlide = function (s) {
      s.classList.remove(ON); s.style.transform = ''; s.style.zIndex = ''; s.style.removeProperty('--dim');
      var im = imgOf(s); if (im) im.style.transform = '';
    };
    var paint = function () {
      var last = trail.length - 1, i = Math.min(Math.floor(pos), last), f = i < last ? pos - i : 0;
      var a = gs[trail[i]], b = f > 0.0001 ? gs[trail[i + 1]] : null, d = dirs[i] || 1;
      hydrate(a); hydrate(b);
      painted.forEach(function (s) { if (s !== a && s !== b) clearSlide(s); });
      a.classList.add(ON); a.style.zIndex = 1;
      a.style.transform = b ? 'translate3d(' + (-d * PAR * f * 100).toFixed(3) + '%,0,0)' : '';
      a.style.setProperty('--dim', b ? (DIM * f).toFixed(3) : '0');
      var ai = imgOf(a); if (ai) ai.style.transform = '';
      painted = [a];
      if (b) {
        var r = 1 - f, bi = imgOf(b);
        b.classList.add(ON); b.style.zIndex = 2;
        b.style.transform = 'translate3d(' + (d * r * 100).toFixed(3) + '%,0,0)';
        b.style.setProperty('--dim', '0');
        if (bi) bi.style.transform = 'translate3d(' + (-d * INNER * r * 100).toFixed(3) + '%,0,0) scale(' + (1 + ZOOM * r).toFixed(4) + ')';
        painted.push(b);
      }
    };
    var settle = function () { trail = [trail[Math.round(pos)]]; dirs = []; pos = 0; paint(); };
    var animate = function (to, ease, D) {
      if (run) cancelAnimationFrame(run);
      var from = pos, t0 = null;
      var tick = function (now) {
        if (t0 === null) t0 = now;
        var u = Math.min(1, (now - t0) / D);
        pos = from + (to - from) * ease(u);
        paint();
        if (u < 1) { run = requestAnimationFrame(tick); return; }
        run = null; pos = to; settle();
      };
      run = requestAnimationFrame(tick);
    };
    /* Punkte: hoechstens 5; das Fenster rueckt nur nach, wenn das aktive Bild seinen Rand verlaesst */
    var paintDots = function (mi) {
      if (!dots.length) return;
      var slots = dots.length;
      if (mi > -1) { if (mi < winStart) winStart = mi; else if (mi > winStart + slots - 1) winStart = mi - slots + 1; }
      winStart = Math.max(0, Math.min(winStart, mains.length - slots));
      dots.forEach(function (d, slot) {
        var idx = winStart + slot, on = idx === mi;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        if (dotTpl) d.setAttribute('aria-label', dotTpl.replace('%i', idx + 1).replace('%n', mains.length));
      });
    };
    /* Logischer Zustand sofort: Punkte, Beschriftung, Vergroessern-Ziel */
    var mark = function (n) {
      cur = n;
      warm(n);
      var mi = mains.indexOf(gs[n]);
      if (mi > -1) lastMain = mi;
      paintDots(mi);
      if (typeof o.onMark === 'function') o.onMark(n, mi, gs[n]);
    };
    /* Immer genau ein Uebergang: das gewaehlte Bild schiebt sich direkt herein, nie durch
       Zwischenbilder blaettern. Richtung: forceDir bei Pfeil/Wischen/Taste (auch vom letzten
       zum ersten Bild), sonst nach Lage in der Liste. */
    var go = function (n, forceDir, instant) {
      var last = trail.length - 1, i = Math.min(Math.floor(pos), last), f = i < last ? pos - i : 0;
      var base = trail[i], top = f ? trail[i + 1] : null, d = f ? dirs[i] : 0;
      mark(n);
      if (instant || reduce) {
        if (run) cancelAnimationFrame(run);
        run = null; trail = [n]; dirs = []; pos = 0; paint();
        return;
      }
      if (!f) {
        if (n === base) return;
        trail = [base, n]; dirs = [forceDir || (n > base ? 1 : -1)]; pos = 0;
        animate(1, EASE_GO, DUR);
        return;
      }
      /* Neues Ziel waehrend der Fahrt: zurueck zum unteren Bild nur, wenn es selbst gewaehlt ist;
         sonst faehrt das obere fertig ein und das neue schiebt sich direkt darueber */
      trail = [base, top]; dirs = [d]; pos = f;
      if (n === base) { animate(0, EASE_ON, Math.max(380, 900 * f)); return; }
      if (n !== top) { trail.push(n); dirs.push(forceDir || (n > top ? 1 : -1)); }
      animate(trail.length - 1, EASE_ON, DUR * (trail.length - 1 - f) * (trail.length > 2 ? 0.8 : 1));
    };
    var show = function (el, D) {
      var n = gs.indexOf(el);
      if (n < 0 || n === cur) return;
      go(n, 0, D === 0);
    };
    var step = function (s) {
      if (mains.length < 2) return;
      var n = gs.indexOf(mains[(lastMain + s + mains.length) % mains.length]);
      if (n !== cur) go(n, s, false);
    };

    dots.forEach(function (d, slot) { d.addEventListener('click', function () { show(mains[winStart + slot]); }); });
    if (o.prev) o.prev.addEventListener('click', function () { step(-1); });
    if (o.next) o.next.addEventListener('click', function () { step(1); });
    if (o.root) {
      var ign = o.swipeIgnore || 'button', gx = null;
      o.root.addEventListener('pointerdown', function (e) { gx = e.target.closest(ign) ? null : e.clientX; });
      o.root.addEventListener('pointerup', function (e) { if (gx === null) return; var dx = e.clientX - gx; gx = null; if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1); });
      o.root.addEventListener('pointercancel', function () { gx = null; });
      o.root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
    }
    paint();
    /* Nach dem Seitenstart die Nachbarn des ersten Bildes vorladen, damit Pfeil und Wischen sofort ein Bild haben */
    var warmLater = function () { setTimeout(function () { warm(cur); }, 300); };
    if (document.readyState === 'complete') warmLater(); else window.addEventListener('load', warmLater, { once: true });

    return {
      show: show,
      showMain: function (i, D) { if (mains[i]) show(mains[i], D); },
      step: step,
      current: function () { return gs[cur]; },
      currentIndex: function () { return cur; },
      lastMain: function () { return lastMain; },
      slides: gs,
      mains: mains
    };
  }

  window.MSGallery = { create: create };
})();
